
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 7h2a1 1 0 001.894.447L6.118 7h7.764l.224.447A1 1 0 0016 7h2v2H2V7zm13.118-2H18a2 2 0 012 2v2a2 2 0 01-1.252 1.855 2.038 2.038 0 01-.042.579l-1.556 7A2 2 0 0115.198 20H4.802a2 2 0 01-1.952-1.566l-1.556-7a2 2 0 01-.043-.579A2 2 0 010 9V7a2 2 0 012-2h2.882L7.106.553a1 1 0 111.788.894L7.118 5h5.764l-1.776-3.553a1 1 0 111.788-.894L15.118 5zM3.247 11h13.506l-1.555 7H4.802l-1.555-7z","fill":"#1A8A5F"}})])
          )
        }
      }
    